export default {
    Search: 'Suche',
    'No results found.': 'Keine Ergebnisse gefunden.',
    cancel: 'beenden'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/searchfield/translations/de.js
// module id = 82
// module chunks = 0